import React from 'react'

import getConfig from 'next/config'

import { ScriptLoader } from '../ScriptLoader/ScriptLoader'

const { publicRuntimeConfig } = getConfig()
const CookiePro = (): JSX.Element => {
  const { cookiepro_url, cookiepro_data_domain } = publicRuntimeConfig
  const [src, setSrc] = React.useState('')
  const [dataDomain, setDataDomain] = React.useState('')
  const [dataLanguage, setDataLanguage] = React.useState('')

  React.useEffect(() => {
    const selectedLocale = getCookie('selected_locale')
    setSrc(cookiepro_url)
    setDataDomain(cookiepro_data_domain)
    if (selectedLocale) {
      if (selectedLocale.toLocaleLowerCase() === 'fr-be') {
        setDataLanguage('fr')
      }
      if (selectedLocale.toLocaleLowerCase() === 'nl-be') {
        setDataLanguage('nl')
      }
    }
  }, [])
  //Not load CookiePro script unless the language is selected
  if (!dataLanguage) {
    return <></>
  }
  return (
    <ScriptLoader
      scriptPlacement="head"
      data-language={dataLanguage}
      charSet="UTF-8"
      src={src}
      data-domain-script={dataDomain}
      type="text/javascript"
    />
  )
}

/**
 * Gets a cookie value based on the key
 * @param key String key of the cookie entry
 * @returns String value of the cookie entry or undefined if is not any entry with the key value
 * @source https://stackoverflow.com/a/15724300
 */
const getCookie = (key: string): string | undefined => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${key}=`)
  if (parts && parts.length === 2) return parts.pop()!.split(';').shift()
}

export default CookiePro
